import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { SwitcherItem, SwitcherDivider, HeaderPanel, Switcher } from '@carbon/react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@/contexts/UserContextProvider';

const DefaultChildren = ({isUserMenuVisible = false, hideUserMenu = () => {}}) => {
  const {isAdmin} = useContext(UserContext);

  let wrapperRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target) &&
      isUserMenuVisible
    ) {
      hideUserMenu();
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isUserMenuVisible, hideUserMenu]);

  useEffect(() => {
    if (isUserMenuVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }
  }, [isUserMenuVisible, handleClickOutside]);

  let history = useNavigate();

  const navigateToProfile = () => {
    hideUserMenu();
    history('/me');
  };

  const handleLogout = () => {
    hideUserMenu();
    history('/logout');
  };

  let adminContent = (
    <>
      <SwitcherDivider></SwitcherDivider>
      <SwitcherItem
        aria-label="go to remote connection"
        href="https://dev.micast.de"
        rel="noopener noreferrer"
        target="_blank">
        Remote Connection
      </SwitcherItem>
    </>
  );

  return (
    <div ref={wrapperRef}>
      <SwitcherItem
        aria-label="account information"
        onClick={navigateToProfile}>
        Konto anzeigen
      </SwitcherItem>
      {isAdmin === false || adminContent}
      <SwitcherDivider></SwitcherDivider>
      <SwitcherItem aria-label="user logout" onClick={handleLogout}>
        Abmelden
      </SwitcherItem>
    </div>
  );
};

const UserSwitcher = ({ children = <DefaultChildren />, isUserMenuVisible = false}) => {
  return (
    <HeaderPanel aria-label="Profil Panel" expanded={isUserMenuVisible} >
      <Switcher aria-label="Profil Panel Container">
        {children}
      </Switcher>
    </HeaderPanel>
  );
};

export { DefaultChildren };
export default UserSwitcher;
